import React, { useState, useCallback, useEffect } from "react";
import { DatePicker, notification } from "antd";
import { Moment } from "moment";

import api from "../../../../api";
import { DISPLAY_DATE_FORMAT, SAVE_DATE_FORMAT } from "@/v1/constants";

interface Props {
  email: string;
  vatLastCheckedAt: Moment | null;
}

export const VatLastCheckedAt = ({ email, vatLastCheckedAt }: Props) => {
  const [vatLastChecked, setVatLastChecked] = useState<Moment | null>(
    vatLastCheckedAt
  );
  const [updatedVatLastChecked, setUpdatedVatLastChecked] =
    useState(vatLastCheckedAt);

  useEffect(() => setVatLastChecked(vatLastCheckedAt), [vatLastCheckedAt]);

  const setVatLastCheckedAt = useCallback(
    async (date: Moment | null) => {
      setVatLastChecked(date);

      const response = await api.kontax.updateNextDeclarationData({
        email,
        vatLastCheckedAt: date ? date.format(SAVE_DATE_FORMAT) : undefined,
      });

      if (!(response instanceof Error)) {
        setUpdatedVatLastChecked(date);
      } else {
        // Set to previous server-side updated vatLastCheckedAt
        // in case the request failed
        setVatLastChecked(updatedVatLastChecked);
        notification.error({ message: "Error updating vatLastCheckedAt" });
      }
    },
    [email, updatedVatLastChecked]
  );
  return (
    <DatePicker
      name="vat_last_checked_at"
      value={vatLastChecked}
      format={DISPLAY_DATE_FORMAT}
      onChange={setVatLastCheckedAt}
    />
  );
};
